export default __webpack_public_path__ + "static/media/baseCalculator.05374ef1.JPG";